export const BASE_URL = "https://www.api.mavricks.vikncodes.com/api/";
export const Media_Url = "https://api.mavricks.vikncodes.com";
